/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'umi';
import PageContainer from '@/pages/dashboard/components/PageContainer';
import { getPageConfig } from '@/pages/dashboard/services/dashboard';
import Loading from '@/pages/dashboard/components/Loadings';
import {
  jsonToString,
  stringToJson,
} from '@/pages/dashboard/utils/stringToJson';
import { CommonPageRenderType, IPageConfigType } from '../type';
import Refresh from '../Refresh';
import Render from '../Render';

import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';

const CommonPageRender = (props: CommonPageRenderType) => {
  const { reqParams, pageConfigInit, renderPageContainer = true } = props;
  const { gameCode, currentMenu, gameConfig, userInfo, currentGame } =
    useSelector(
      (state: any) => ({
        gameCode: state?.dashboard?.currentGame?.game_code,
        currentMenu: state?.dashboard?.currentMenu,
        gameConfig: state?.dashboardSetting?.gameConfig || {},
        userInfo: state?.home?.userInfo,
        currentGame: state?.dashboard?.currentGame,
      }),
      shallowEqual,
    );

  const data = {
    gameCode,
    currentMenu,
    gameConfig,
    userInfo,
    currentGame,
  };

  const [pageConfig, setPageConfig] = useState<IPageConfigType>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPageConfig({
      game_code: gameCode,
      path: reqParams,
    })
      .then((res) => {
        const resDataConfig = res?.dashboard_view_config?.view_config;
        const config = resDataConfig ? stringToJson(resDataConfig) : pageConfigInit;
        // console.log('入库配置',jsonToString(pageConfigInit));
        setPageConfig(config);
        setLoading(false);
      })
      .catch((err) => {
        console.log('后端配置错误或者配置为空', err);
        setPageConfig(pageConfigInit);
        setLoading(false);
      });
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        pageConfig && (
          <Refresh>
            {pageConfig?.isRender || !renderPageContainer ? (
              <Render data={data} config={pageConfig} />
            ) : (
              <PageContainer data={data} config={pageConfig} />
            )}
          </Refresh>
        )
      )}
    </>
  );
};

export default CommonPageRender;
